import { pslClient } from "@/common/http-common";
import {
  API_URL_GET_APP_BUSINESS_TIME,
  API_URL_GET_APP_CONFIGURATION,
} from "@/constants/api.constants.js";
import axios from "axios";

class AppConfigurationService {
  getBusinessTime() {
    return axios
      .get(API_URL_GET_APP_BUSINESS_TIME)
      .then((res) => {
        return res.data?.result;
      })
      .catch((err) => console.error(err));
  }

  async getAppConfigurationByType(config, type) {
    let url = `${API_URL_GET_APP_CONFIGURATION}/${type}`;
    return pslClient
      .get(url, config)
      .then((res) => {
        return res.data?.Value?.Value;
      })
      .catch((err) => console.error(err));
  }
}

export default new AppConfigurationService();
